'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.dispatchAction = dispatchAction;

var _config = require('./core/config');

var _config2 = _interopRequireDefault(_config);

var _components = require('./core/components');

var _components2 = _interopRequireDefault(_components);

var _store = require('./core/store');

var _store2 = _interopRequireDefault(_store);

var _reducers = require('./core/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _actions = require('./core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _notify = require('./notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('./message');

var _message2 = _interopRequireDefault(_message);

var _event = require('./core/event');

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
// const modules = {
// 	config: require('./core/config').default,
// 	components: require('./core/components').default,
// 	store: require('./core/store').default,
// 	reducers: require('./core/reducers').default,
// 	actions: require('./core/actions').default
// };

// modules.default = modules;
function dispatchAction(action) {
	_store2.default.get().dispatch(action);
}

exports.default = {
	config: _config2.default,
	components: _components2.default,
	store: _store2.default,
	reducers: _reducers2.default,
	actions: _actions2.default,
	notify: _notify2.default,
	message: _message2.default,
	event: _event2.default,
	dispatchAction: dispatchAction
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/index.js
// module id = 592
// module chunks = 0